import React from 'react';
export function Comparison() {
  return <section id="porque" className="py-20 bg-gray-50" data-id="element-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="text-center mb-16" data-id="element-14">
          <h2 className="text-4xl font-light text-gray-900 mb-4" data-id="element-15">
            Ejemplo de Compra vs Arrendamiento Puro
          </h2>
          <p className="text-xl text-gray-600" data-id="element-16">
            Un cálculo para mostrar la ventaja en deducibilidad anual de un
            arrendamiento comparado con una compra en contado.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-17">
          {/* Purchase Card */}
          <div className="bg-white rounded-lg shadow-md p-8" data-id="element-18">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-19">
              Compra
            </h3>
            <div className="text-center mb-8" data-id="element-20">
              <div className="text-5xl font-bold text-gray-900 mb-2" data-id="element-21">
                $53,500
              </div>
              <div className="text-gray-600" data-id="element-22">deducibilidad anual</div>
            </div>
            <div className="space-y-4" data-id="element-23">
              <div className="flex justify-between py-3 border-b" data-id="element-24">
                <span className="text-gray-600" data-id="element-25">Valor del vehículo</span>
                <span className="font-semibold" data-id="element-26">$390,000</span>
              </div>
              <div className="flex justify-between py-3 border-b" data-id="element-27">
                <span className="text-gray-600" data-id="element-28">
                  Gasto estimado anual de gasolina
                </span>
                <span className="font-semibold" data-id="element-29">$36,000</span>
              </div>
              <div className="flex justify-between py-3 border-b" data-id="element-30">
                <span className="text-gray-600" data-id="element-31">
                  Gasto estimado anual mantenimiento
                </span>
                <span className="font-semibold" data-id="element-32">$15,000</span>
              </div>
              <div className="flex justify-between py-3" data-id="element-33">
                <span className="text-gray-600" data-id="element-34">Seguro</span>
                <span className="font-semibold" data-id="element-35">$12,000</span>
              </div>
            </div>
          </div>

          {/* Lease Card */}
          <div className="bg-white rounded-lg shadow-md p-8 border-2 border-[#2BA6DE]" data-id="element-36">
            <div className="bg-[#2BA6DE] text-white text-center py-2 -mx-8 -mt-8 mb-6 rounded-t-lg" data-id="element-37">
              * Más Lógico
            </div>
            <h3 className="text-2xl font-bold text-[#2BA6DE] mb-6 text-center" data-id="element-38">
              Arrendamiento Puro
            </h3>
            <div className="text-center mb-8" data-id="element-39">
              <div className="text-5xl font-bold text-[#2BA6DE] mb-2" data-id="element-40">
                $135,000
              </div>
              <div className="text-gray-600" data-id="element-41">deducibilidad anual</div>
            </div>
            <div className="space-y-4" data-id="element-42">
              <div className="flex justify-between py-3 border-b" data-id="element-43">
                <span className="text-gray-600" data-id="element-44">
                  Renta de Arrendamiento Puro
                </span>
                <span className="font-semibold" data-id="element-45">$9,985 mensuales</span>
              </div>
              <div className="flex justify-between py-3 border-b" data-id="element-46">
                <span className="text-gray-600" data-id="element-47">
                  Gasto estimado anual de gasolina
                </span>
                <span className="font-semibold" data-id="element-48">$36,000</span>
              </div>
              <div className="flex justify-between py-3 border-b" data-id="element-49">
                <span className="text-gray-600" data-id="element-50">
                  Gasto estimado anual mantenimiento
                </span>
                <span className="font-semibold" data-id="element-51">$15,000</span>
              </div>
              <div className="flex justify-between py-3 mb-6" data-id="element-52">
                <span className="text-gray-600" data-id="element-53">Seguro</span>
                <span className="font-semibold" data-id="element-54">$12,000</span>
              </div>
              <button className="w-full bg-[#2BA6DE] text-white py-3 rounded-md font-medium hover:bg-[#2495c8] transition-colors" data-id="element-55">
                Cotiza tu arrendamiento
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}